export const ExposureTestNames = {
  INTRO_FUNNEL: 'newBookingsIntroV2',
};
